/**
 * Static credit text shown to Music Creator partners.
 * Single source of truth — used by:
 *  - Download Modal step 2 (NextStepsPage)
 *  - Music Creator action-required cards on /account/claims (Show Credit Text)
 *
 * If you change this, both surfaces update at once.
 */
export const CREATOR_CREDIT_TEXT =
  `🎧 𝐒𝐓𝐑𝐄𝐀𝐌\n` +
  `→ https://open.spotify.com/playlist/0cwkdBJUn5dsfubOkTyo4a\n` +
  `→ https://soundcloud.audiosanctum.com\n` +
  `→ also find us on all other Streaming Platforms!\n\n` +
  `🤝 𝐔𝐒𝐄 𝐎𝐔𝐑 𝐌𝐔𝐒𝐈𝐂\n` +
  `→ Free Use: https://audiosanctum.com/free-youtube-music\n` +
  `→ Licensing: https://audiosanctum.com/licensing\n` +
  `→ YouTube Music Creators: https://audiosanctum.com/music-creator\n\n` +
  `🛒 𝐁𝐔𝐘\n` +
  `→ MP3, CD & Merch: https://www.sanctum.shop\n` +
  `→ Bandcamp: https://audiosanctum.bandcamp.com\n\n` +
  `🎵 𝐂𝐎𝐍𝐍𝐄𝐂𝐓\n` +
  `→ https://audiosanctum.com\n` +
  `→ https://instagram.audiosanctum.com\n` +
  `→ https://facebook.audiosanctum.com\n` +
  `→ https://newsletter.audiosanctum.com\n\n` +
  `👉 𝐖𝐎𝐑𝐊 𝐖𝐈𝐓𝐇 𝐔𝐒\n` +
  `→ Composer & Artist Submissions: https://audiosanctum.com/submit\n` +
  `→ Music YouTubers: https://audiosanctum.com/music-creator`;
